import Vue from 'vue';
import Vuex, { MutationTree, ActionTree } from 'vuex';
import { WorksheetColumns } from '@/components/prine/enums/WorksheetColumns';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import { pmAppliedLessonWebservice } from '@/webservices/pmappliedlesson';
import { appliedLessonWebservice } from '@/webservices/appliedlesson';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import { xAppliedLessonWebservice } from '@/webservices/xappliedlesson';

Vue.use(Vuex);

interface State {
    selectedWorksheetColumns: WorksheetColumns[];
    toDoAppliedLessons: AppliedLesson[];
    toDoPMAppliedLessons: PMAppliedLesson[];
    toDoXAppliedLessons: XAppliedLesson[];
}

const mutations: MutationTree<State> = {
    setSelectedWorksheetColumns(currentState, selectedWorksheetColumns: WorksheetColumns[]) {
        currentState.selectedWorksheetColumns = selectedWorksheetColumns;
    },

    setToDoAppliedLessons(currentState, appliedlessons: AppliedLesson[]) {
        currentState.toDoAppliedLessons = appliedlessons;
    },

    setToDoPMAppliedLessons(currentState, appliedlessons: PMAppliedLesson[]) {
        currentState.toDoPMAppliedLessons = appliedlessons;
    },

    setToDoXAppliedLessons(currentState, appliedlessons: XAppliedLesson[]) {
        currentState.toDoXAppliedLessons = appliedlessons;
    },

    resetState() {
        // console.log('resetState FIRED FROM Account STORE');
        // acquire initial state
        const s = initialState();

        Object.keys(s).forEach((key) => {
            state[key] = s[key];
        });
    },
};

const actions: ActionTree<State, any> = {
    fetchAllToDos({ commit }): any {
        appliedLessonWebservice.getToDos().then((responseAppliedLesson) => {
            pmAppliedLessonWebservice.getToDos().then((responsePMAppliedLesson) => {
                xAppliedLessonWebservice.getToDos().then((responseXAppliedLesson) => {
                    const toDoAppliedLessons: AppliedLesson[] = responseAppliedLesson && responseAppliedLesson.data;
                    commit('setToDoAppliedLessons', toDoAppliedLessons);

                    const toDoPMAppliedLessons: PMAppliedLesson[] =
                        responsePMAppliedLesson && responsePMAppliedLesson.data;
                    commit('setToDoPMAppliedLessons', toDoPMAppliedLessons);

                    const toDoXAppliedLessons: XAppliedLesson[] = responseXAppliedLesson && responseXAppliedLesson.data;
                    commit('setToDoXAppliedLessons', toDoXAppliedLessons);
                });
            });
        });
    },
};

const getters = {
    selectedWorksheetColumns(currentState: State): WorksheetColumns[] {
        return currentState.selectedWorksheetColumns;
    },

    toDoAppliedLessons(currentState: State): AppliedLesson[] {
        return currentState.toDoAppliedLessons;
    },

    toDoPMAppliedLessons(currentState: State): PMAppliedLesson[] {
        return currentState.toDoPMAppliedLessons;
    },

    toDoXAppliedLessons(currentState: State): XAppliedLesson[] {
        return currentState.toDoXAppliedLessons;
    },

    countAllToDos(currentState: State): number {
        return (
            currentState.toDoAppliedLessons.length +
            currentState.toDoPMAppliedLessons.length +
            currentState.toDoXAppliedLessons.length
        );
    },
};

function initialState() {
    return {
        selectedWorksheetColumns: [WorksheetColumns.toDo],
        toDoAppliedLessons: Array<AppliedLesson>(),
        toDoPMAppliedLessons: Array<PMAppliedLesson>(),
        toDoXAppliedLessons: Array<XAppliedLesson>(),
    };
}

const state: State = initialState();

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default module;
